import React, { Component } from 'react'
import { connect } from 'react-redux';

import classnames from "classnames";
import Button from './../shared/Button/index';

import styles from './../../styles/perfect_essay.styl';
import baseStyles from 'custom/base.styl';
import success from './../../img/success@3x.png';

import { profileUpdateStages } from "../../store/profile/actions";

class EssayPhilosophy extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 'step1',
    }

    this.onStepClick = this.onStepClick.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStageNext = this.onStageNext.bind(this)
  }

  onStepClick(e) {
    const newStep = e.target.dataset.step;
    // let offsetTop  = e.target.getBoundingClientRect().top;

    this.setState({
      curStep: newStep,
    });
    // e.target.scrollIntoView({ behavior: "smooth" });
    const el = document.getElementById(newStep);
    el.scrollIntoView({ behavior: "smooth" });


    // this.setState({
    //   curStep: newStep,
    // }, () => window.scrollTo({ top: offsetTop, behavior: 'smooth' }));
  }

  onComplete() {
    this.setState({
      curStep: 'finish',
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { curStep } = this.state;

    return (
      <div>
        {/* page-1 */}
        <div className={classnames(styles.perfect_essay)}>

          <div className={classnames(styles.comment_finish, { [styles.active]: curStep === 'finish' })}>
            <img src={success} alt="success" width="100px" />
            <h3>Thank you for completing <br /> the first essay</h3>
						<p>There’s only one test essay left <br /> before you join us as a writer and <br /> start working with real orders. <br /> Show there all your academic <br /> knowledge and writing skills, as we <br /> will check it thoroughly to decide <br /> whether you have passed the <br /> probation.</p>
            <Button onClick={(e) => this.onStageNext(e)} block >Begin the last essay</Button>
          </div>

          <div className={styles.catchword}>Student’s Last Name 1</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step1' })} data-step="step1" id="step1">

            <div className={styles.highlighting_content}>
              <header>
                Student’s Name <br />
                Professor’s Name <br />
                Subject <br />
                DD MM YYYY <br />
              </header>

              <div className={styles.center}>Artworks vs. Photographs</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The paper follows the requirements of the MLA formatting style.</li>
                  <li>No personal information is included.</li>
                  <li>Please download a template to avoid mistakes and spend less time on formatting.</li>
                </ul>
                <div className={classnames(styles.btn_wrap, baseStyles.flex_right)}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">NEXT&rarr;&nbsp;</button>
                </div>
              </div>

            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step2' })} data-step="step2" id="step2">
            <div className={styles.highlighting_content}>
              <p>It is possible to distinguish works of art from photographs in photojournalism with the help of Danto’s theory which defines art by such criteria as meaning, embodiment, and viewer’s interpretation.</p>

              <div className={styles.comment}>
                <ul>
                  <li>The instructions are followed: the paper answers the required question “How would Arthur Danto's views enable us to decide which ones are artworks and which ones are just phonographs?” explicitly.  </li>
                  <li>Structure: The introduction contains an arguable thesis statement.</li>
                  <li>The word count of the introduction is 10%.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step1">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step3' })} data-step="step3" id="step3">
            <div className={styles.highlighting_content}>
              <p>The photograph presents the meaning of an object from a photographer’s point of view. According to Danto’s theory, the embodiment of art must be clear and present the journalist’s distinct idea provoking particular feelings and emotions that determine the meaning of the art (44). Thus, a photograph might not be interpreted correctly by the observer and, thus, cannot be considered as an artwork. The interpretation of the photograph is the final criteria to determine if it is a piece of art, although, it may vary from person to person. It happens due to the fact that they might not have experienced the same feeling when viewing the photograph.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph discusses one idea that is a part of the thesis statement.</li>
                  <li>Structure: The paragraph begins with a topic sentence that explains the main idea. It is followed by the analysis supported with outside information cited in MLA.</li>
                  <li>Language: No personal pronouns, phrasal verbs, contractions, idioms, colloquial language, rhetorical questions are used.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type4, { [styles.active]: curStep === 'step4' })} data-step="step4" id="step4">
            <div className={styles.highlighting_content}>
              <p> In addition, the photography can totally be an art, but in some ways it lacks technical pursuits, that a painting has. It is claimed that “The photographer can represent only what is there, whereas the painter is free to use his imagination and show things in ways other than how they are or were” (Danto 42). The camera is able to capture an optic but not a visual truth of an object.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph is devoted to one idea that relates to the thesis and is supported with an example from the outside source.</li>
                  <li>Plagiarism: Direct quotations do not exceed 10% of the required word count. No unsupported claims are present in the paper.</li>
                  <li>Structure: The paragraph contains at least 3 sentences and does not exceed 200 words. It begins with a linking word that contributes to the logical flow of the essay.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step5' })} data-step="step5" id="step5">
            <div className={styles.highlighting_content}>
              <p>Many people argue that original art has lost some of its sensation due to it mostly being a mass-produced copy. An ordinary person may see a photograph as a great masterpiece. The mechanically reproduced photographs lack a special veneer of authenticity. However the photograph might fulfill all the criteria outlined by Arthur Danto, it will lack authenticity that a painting has.</p>
              <div className={classnames(styles.comment, styles.comment_bottom)}>
                <ul>
                  <li>Content: The paragraph answers the required question “Since the photographs can be mechanically reproduced, do Danto’s views still apply?” explicitly.</li>
                  {/* <li> Conclusion restates the thesis statement and the arguments discussed in the main body. It includes no in-text citations and no new information.</li> */}
                  <li>Word count of the body paragraphs comprise 80% (240 words).</li>
                  <li>Proofreading: No repetitions, misprints, punctuation issues are present in the paper.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step6">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step6' })} data-step="step6" id="step6">
            <div className={styles.highlighting_content}>
              <p>Although interpretations in terms of authenticity vary, Danto’s theory helps differentiate between photographs and pieces of art by analyzing them according to such criteria as meaning, embodiment, and viewer’s interpretation.</p>
              <div className={classnames(styles.comment, styles.comment_bottom)}>
                <ul>
                  <li>Content: The Conclusion contains no new information and restates the thesis. </li>
                  <li>Structure: The word count of the Conclusion is 10% of the required word count (1 page = 300 words). </li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step7">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* page-2 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword}>Student’s Last Name 2</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step7' })} data-step="step7" id="step7">

            <div className={styles.highlighting_content}>

              <div className={styles.center}>Works Cited</div>

              <div>Danto, Arthur Coleman. <i>What Art Is</i>. Yale University Press, 2013.</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The minimum requirement to include 1 source per 1 page (300 words) is met.</li>
                  <li>The incorporated source is reliable, relevant (published within the last 5-7 years), and to the topic.</li>
                  <li>Works Cited page is formatted according to the requirements of the MLA formatting style. </li>
                  <li>In case the paper contains more than one source, the list should be alphabetized.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step6">&larr;&nbsp;PREVIOUS</button>
                  <Button onClick={(e) => this.onComplete(e)} className={styles.btn_finish} light>Finish</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(null, mapDispatchToProps)(EssayPhilosophy);




// WEBPACK FOOTER //
// ./src/components/PerfectEssay/EssayPhilosophy.js